
import { useState, useEffect } from 'react';
import Header from './components/Header';
import ScoreDisplay from './components/ScoreDisplay';
import GameArea from './components/GameArea';
import Footer from './components/Footer';

export default function Home() {
  const [score, setScore] = useState(0);
  const [backgroundCookies, setBackgroundCookies] = useState<Array<{ id: number; x: number; y: number; rotation: number; size: number }>>([]);

  useEffect(() => {
    // Generate background cookies based on score
    const cookies = [];
    for (let i = 0; i < score; i++) {
      cookies.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        rotation: Math.random() * 360,
        size: 20 + Math.random() * 30
      });
    }
    setBackgroundCookies(cookies);
  }, [score]);

  const handleCookieClick = () => {
    setScore(prev => prev + 1);
  };

  const handleReset = () => {
    setScore(0);
    setBackgroundCookies([]);
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 overflow-hidden">
      {/* Background Cookies */}
      <div className="fixed inset-0 pointer-events-none opacity-50">
        {backgroundCookies.map((cookie) => (
          <div
            key={cookie.id}
            className="absolute text-amber-600"
            style={{
              left: `${cookie.x}%`,
              top: `${cookie.y}%`,
              transform: `rotate(${cookie.rotation}deg)`,
              fontSize: `${cookie.size}px`
            }}
          >
            🍪
          </div>
        ))}
      </div>

      {/* Main Content */}
      <div className="relative z-10">
        <Header />
        <ScoreDisplay score={score} onReset={handleReset} />
        <GameArea onCookieClick={handleCookieClick} score={score} />
        <Footer />
      </div>
    </div>
  );
}
